'use strict';

var customUtil = require('../customUtil.js');

// Clones main image container and replaces src attributes
function createZoomSlider($mainCarousel) {
    // Need to unslick slider to get the correct order of carousel items
    var mainIsSlick = $mainCarousel.hasClass('slick-initialized')
    if (mainIsSlick) {
        $mainCarousel.slick('unslick');
    }

    var $slider = $mainCarousel.clone().attr({
        'class': 'zoom-carousel carousel-inner',
        'data-slick' : ''
    });

    var $carouselItems = $mainCarousel.find('.carousel-item');
    for (var i = 0; i < $carouselItems.length; i++) {
        var $mainCarouselItem = $($mainCarousel.find('.carousel-item')[i]);
        var $sliderCarouselImage = $($slider.find('.carousel-item img')[i]);
        var $img = $mainCarouselItem.find('img');
        var zoomUrl = $img.data('zoomUrl');
        if (zoomUrl) {
            $sliderCarouselImage.attr('src', zoomUrl);
        } else {
            $slider.remove($sliderCarouselImage);
        }
    }

    if (mainIsSlick) {
        $mainCarousel.slick();
    }

    return $slider;
}

function updateAndShowModal($img) {
    var zoomImageURL = $img.data('zoomUrl');
    if (!zoomImageURL) {
        return;
    }

    var index = $img.data('slickIndex');
    var $zoomCarousel = $('#productZoomModal').find('.zoom-carousel');

    if ($zoomCarousel.length > 0 && $zoomCarousel.hasClass('slick-initialized')) {
        $zoomCarousel.slick('slickGoTo', index);
    } else if ($zoomCarousel.length > 0) {
        $zoomCarousel.attr('data-slick-index', index);
    } else {
        var $imageModalContent = $('#productZoomModal').find('.modal-body');
        $imageModalContent.empty();
        var zoomImage = $img.clone();
        zoomImage[0].src = zoomImageURL;
        $imageModalContent.html(zoomImage);
    }

    $('#productZoomModal').modal('show');

    // Remove hidden class if they haven't been loaded before clicking the zoom carousel
    $('.zoom-carousel .carousel-item').removeClass('d-lg-none');
}

/**
 * Custom Product Zoom Init Function
 * Open Modal on PDP using Hi-Res product zoom image if available
 */
function initProductZoom() {
    createProductZoomModal();
    $('body').on('click', '.js-zoom-image img', function (e) {
        if (customUtil.isMobile()) {
            return;
        }
        updateAndShowModal($(this));
    });

    $('body').on('click', '.js-zoom-image .zoom-icon', function () {
        if (customUtil.isMobile()) {
            updateAndShowModal($(this).siblings('img'));
        }
    });

    $('body').on('show.bs.modal', '#productZoomModal', function() {
        var $zoomCarousel = $(this).find('.zoom-carousel');
        var index = $zoomCarousel.attr('data-slick-index');

        if ($zoomCarousel.hasClass('slick-initialized') || $zoomCarousel.find('.carousel-item') < 2) {
            return;
        }

        $zoomCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            initialSlide: index,
            arrows: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true
                    }
                }
            ]
        });
    });

    // Takes care of aria-hidden warning
    $(document).on('hide.bs.modal', function () {
        if (document.activeElement) {
            document.activeElement.blur();
        }
    });
}

/**
 * Generic Modal Creation Function
 * in the style of OOTB modal creation functions (i.e chooseBonusProductModal)
 */
function createProductZoomModal() {
    if ($('#productZoomModal').length === 0) {
        var htmlString = '<!-- Modal -->'
        + '<div class="modal fade product-zoom-modal" id="productZoomModal" tabindex="-1" role="dialog">'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="sr-only">Close</span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
        $('body').append(htmlString);
    
        var $mainCarousel = $('.pdp-main-carousel');
    
        if ($mainCarousel.find('.carousel-item').length > 1) {
            var $slider = createZoomSlider($mainCarousel);
            $('#productZoomModal').find('.modal-body').html($slider);
        }
    }
}

module.exports = {
    initProductZoom: initProductZoom,
    createProductZoomModal: createProductZoomModal
}